import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { AppStoreProvider } from './stores';
import { TabModel } from '../common/types/TabModel';
import { AppContent } from './components';

interface Props {
    tab: TabModel;
}

const CustomUiDemoApp: React.FC<Props> = ({ tab }) => {
    return (
        <AppStoreProvider tab={tab}>
            <AppContent />
        </AppStoreProvider>
    );
};

export default observer(CustomUiDemoApp);
